var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-overlay", { attrs: { show: _vm.is_load } }, [
    this.tree.length > 0
      ? _c(
          "div",
          { staticClass: "categ_list p-5" },
          [
            _c("categlist_product", {
              attrs: { categories: _vm.tree },
              on: { change: _vm.on_set },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }